import script from "./LeaderProjectFormStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep2.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep2.vue?vue&type=style&index=0&id=1273da86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1273da86"]])

export default __exports__